import React, { useEffect, useState, useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { CheckCircle2, MapPin, Award, Play, FileText } from 'lucide-react';
import { VideoModal } from './VideoModal';
export function Hero() {
  const {
    scrollY
  } = useScroll();
  const y = useTransform(scrollY, [0, 800], [0, 200]);
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  return <section className="relative w-full pt-40 pb-28 lg:pt-52 lg:pb-24 overflow-hidden" data-id="element-356" data-mp="12a0kra1zryu3">
      {/* Image Background */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-357" data-mp="xbfmvha7pr8t">
        <img src="https://cdn.magicpatterns.com/uploads/gHgy89W3EcSExnvbgaMzow/hero_bg5.jpg" alt="Real estate professional" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-358" data-mp="sbb0xbqjc4b7" />
      </div>

      {/* Heavy Dark Base Layer - Reduced by 15% (70% to 55%) */}
      <div className="absolute inset-0 bg-gray-950/55" data-id="element-359" data-mp="382p55bt4dbkm" />

      {/* Purple Tint Layer - Keep same */}
      <div className="absolute inset-0 bg-brand-purple-900/40 mix-blend-multiply" data-id="element-360" data-mp="3j7zf9iqmlsgo" />

      {/* Deep Gradient Vignette - Reduced by 15% (75% to 60%) */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-purple-950/60 via-transparent to-brand-purple-950/60" data-id="element-361" data-mp="3o6u7tceeavdz" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-362" data-mp="39cpfl1np9x62">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center" data-id="element-363" data-mp="3e7l6fyh7aehl">
          {/* Left Content */}
          <motion.div className="lg:col-span-7 space-y-8 text-center lg:text-left" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-364" data-mp="30g6kbirzxx6b">
            <div className="space-y-4" data-id="element-365" data-mp="2hk83vz8alnf4">
              <motion.div className="inline-flex items-center px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-white text-sm font-medium mx-auto lg:mx-0" initial={{
              scale: 0.9,
              opacity: 0
            }} animate={{
              scale: 1,
              opacity: 1
            }} transition={{
              delay: 0.2
            }} data-id="element-366" data-mp="2hl9rf36hw2dq">
                <MapPin className="w-4 h-4 mr-1.5" data-id="element-367" data-mp="dbaowzcid6ur" />
                Arizona's Premier Real Estate School
              </motion.div>

              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-tight" data-id="element-368" data-mp="161b01fxlrg62">
                Arizona Real Estate <br className="hidden lg:block" data-id="element-369" data-mp="11150ldl3cpdf" />
                <span className="text-brand-orange-300" data-id="element-370" data-mp="x1eehn6iexf8">License Renewal</span>
              </h1>

              <p className="text-xl sm:text-2xl text-white font-semibold" data-id="element-371" data-mp="3lsp1x9cpsbcb">
                Continuing Education Made Simple
              </p>

              <p className="text-lg text-white/90 max-w-2xl mx-auto lg:mx-0" data-id="element-372" data-mp="3hqkbejhkbutw">
                On-Demand, Zoom, and In-person CE classes — built specifically
                for Arizona Agents and Brokers. Get your hours done quickly and
                conveniently.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full max-w-xl mx-auto lg:mx-0" data-id="element-373" data-mp="2697ogn09l808">
              <a href="/Products" className="flex items-center justify-center h-14 px-5 rounded-md text-base leading-tight text-center bg-brand-purple-600 hover:bg-brand-purple-700 text-white font-bold shadow-xl hover:shadow-2xl transition-[background-color,box-shadow] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-brand-purple-900" data-id="element-374" data-mp="2b2ahmu14qffw">
                View On-Demand Classes
              </a>
              <a href="/LiveClasses.html" className="flex items-center justify-center h-14 px-5 rounded-md text-base leading-tight text-center bg-white/10 hover:bg-white/20 text-white backdrop-blur-sm border-2 border-white/20 font-semibold shadow-xl transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-brand-purple-900" data-id="element-375" data-mp="uokd5m63lp5q">
                Calendar of In-Person/Zoom Classes
              </a>
            </div>

            {/* Video Teaser */}
            <button onClick={() => setIsVideoOpen(true)} className="group inline-flex items-center gap-3 px-5 py-3 bg-white/10 backdrop-blur-md rounded-xl border-2 border-white/20 hover:bg-white/20 hover:border-white/30 transition-all mx-auto lg:mx-0 shadow-lg" data-id="element-376" data-mp="3hqsco67lzvix">
              <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center group-hover:scale-110 transition-transform shadow-md" data-id="element-377" data-mp="3mo2c8eoppnkh">
                <Play className="w-5 h-5 text-brand-purple-600 fill-brand-purple-600 ml-0.5" data-id="element-378" data-mp="2u17tbm7jmw94" />
              </div>
              <div className="text-left" data-id="element-379" data-mp="19idpw68xe5q8">
                <div className="text-sm font-semibold text-white" data-id="element-380" data-mp="19gkkeua1trjt">
                  Watch a Quick Intro
                </div>
                <div className="text-xs text-white/80" data-id="element-381" data-mp="zkhgpjzjtkur">
                  How license renewal works with Desert Sage Seminars
                </div>
              </div>
            </button>

            {/* Trust Signals */}
            <div className="pt-4 flex flex-wrap justify-center lg:justify-start gap-x-8 gap-y-4 text-sm" data-id="element-382" data-mp="1s8vhu8lxoxaj">
              <div className="flex items-center bg-white/10 backdrop-blur-sm px-3 py-2 rounded-lg border border-white/20" data-id="element-383" data-mp="1x76sglk1zbtt">
                <CheckCircle2 className="w-4 h-4 text-green-300 mr-2" data-id="element-384" data-mp="1j7xb3ik42bo9" />
                <span className="text-white font-medium" data-id="element-385" data-mp="1n9ag5qfdqau4">
                  ADRE School #S06-0002
                </span>
              </div>
              <div className="flex items-center bg-white/10 backdrop-blur-sm px-3 py-2 rounded-lg border border-white/20" data-id="element-386" data-mp="7s0dz724clfy">
                <Award className="w-4 h-4 text-brand-orange-300 mr-2" data-id="element-387" data-mp="2ehkf9a2l6nbl" />
                <span className="text-white font-medium" data-id="element-388" data-mp="2egsi3utcchj7">REEA Member</span>
              </div>
              <div className="flex items-center bg-white/10 backdrop-blur-sm px-3 py-2 rounded-lg border border-white/20" data-id="element-389" data-mp="29j9671k48guf">
                <MapPin className="w-4 h-4 text-white mr-2" data-id="element-390" data-mp="24pef3d26kzlb" />
                <span className="text-white font-medium" data-id="element-391" data-mp="1zs4se566f216">
                  Locally Owned & Operated
                </span>
              </div>
            </div>
          </motion.div>

          {/* Right Content - License Summaries */}
          <motion.div className="lg:col-span-5 w-full space-y-4" initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-392" data-mp="1qucb4vgw9kb5">
            <a href="/License_Information" className="block bg-white/10 backdrop-blur-md rounded-xl border border-white/20 p-6 hover:bg-white/20 transition-all hover:-translate-y-1 shadow-xl group" data-id="element-393" data-mp="3b94jwykp9cu5">
              <div className="flex items-start" data-id="element-394" data-mp="3no2l28yzho4y">
                <div className="bg-brand-orange-400 p-3 rounded-lg mr-4 group-hover:scale-110 transition-transform" data-id="element-395" data-mp="3si6tkwnwe485">
                  <FileText className="w-6 h-6 text-brand-purple-900" data-id="element-396" data-mp="1achppg03kmf" />
                </div>
                <div data-id="element-397" data-mp="30ranqg098zud">
                  <h3 className="text-xl font-bold text-white mb-1" data-id="element-398" data-mp="30s2bx5rivvam">
                    AGENTS NEED
                  </h3>
                  <p className="text-brand-orange-300 font-medium mb-2" data-id="element-399" data-mp="39qnqyqxscs6n">
                    Salesperson/Associate Broker
                  </p>
                  <div className="flex items-center text-white/90" data-id="element-400" data-mp="3eqjvcraealmq">
                    <span className="font-bold text-2xl mr-2" data-id="element-401" data-mp="p0ybcbp9d2cw">24 hrs.</span>
                    <span className="text-sm" data-id="element-402" data-mp="p2t1c4fdzknu">every 2-year cycle</span>
                  </div>
                </div>
              </div>
            </a>

            <a href="/License_Information" className="block bg-white/10 backdrop-blur-md rounded-xl border border-white/20 p-6 hover:bg-white/20 transition-all hover:-translate-y-1 shadow-xl group" data-id="element-403" data-mp="1f4dfa94zh55a">
              <div className="flex items-start" data-id="element-404" data-mp="1ov833hxvocsu">
                <div className="bg-brand-purple-600 p-3 rounded-lg mr-4 group-hover:scale-110 transition-transform" data-id="element-405" data-mp="1k1lz0e5s5h8n">
                  <FileText className="w-6 h-6 text-white" data-id="element-406" data-mp="1ypzyqg7wgpkz" />
                </div>
                <div data-id="element-407" data-mp="1trf02l8aqdyn">
                  <h3 className="text-xl font-bold text-white mb-1" data-id="element-408" data-mp="1trykq9pbzggd">
                    BROKERS NEED
                  </h3>
                  <p className="text-brand-purple-300 font-medium mb-2" data-id="element-409" data-mp="27pveyzgbbarv">
                    Designated Broker / Delegated Broker / Self Employed Broker
                  </p>
                  <div className="flex items-center text-white/90" data-id="element-410" data-mp="degpmjr7rdcn">
                    <span className="font-bold text-2xl mr-2" data-id="element-411" data-mp="8g6to6xo08pz">30 hrs.</span>
                    <span className="text-sm" data-id="element-412" data-mp="2k2qppopj7qxf">every 2-year cycle</span>
                  </div>
                </div>
              </div>
            </a>
          </motion.div>
        </div>
      </div>

      {/* Video Modal */}
      <VideoModal isOpen={isVideoOpen} onClose={() => setIsVideoOpen(false)} videoId="OhJuESLnDqk" title="Desert Sage Seminars — Welcome" data-id="element-413" data-mp="2b940khftxlx7" />
    </section>;
}